import { useAuditApi } from "./common/auditApi";

export function useVehicleAuditApi() {
  return useAuditApi({
    url: 'vehicle',
    translateTitle: (t) => t.audit.actions.fetchVehicle.title,
    translateError: (t) => t.audit.actions.fetchVehicle.error,
  });
}
